<template>
  <div
    ref="chatCarousel"
    v-if="isOpened"
    @keyup.esc.stop="close"
    class="chat-carousel"
    tabindex="0">
    <div class="chat-carousel__wrapper">
      <div class="chat-carousel__content">
        <div
          @click="close"
          class="chat-carousel__content-icon">
          <close-icon/>
        </div>
        <img
          v-if="showImage"
          class="chat-carousel__content-image"
          v-lazy="sourceUrl"/>
        <video-player
          v-if="showVideo"
          :options="videoOptions"/>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CAROUSEL_HIDE,
  CAROUSEL_OPEN,
} from '@/eventTypes';
import EventBus from '@/eventBus';
import CloseIcon from '@/assets/icons/close.svg';
import VideoPlayer from '@/components/shared/VideoPlayer.vue';

export default {
  components: {
    CloseIcon,
    VideoPlayer,
  },
  data() {
    return {
      isOpened: false,
      currentUrl: '',
      currentType: '',
    };
  },
  computed: {
    sourceUrl() {
      return this.currentUrl;
    },
    showImage() {
      return this.currentType === 'image' && this.currentUrl.length > 0;
    },
    showVideo() {
      return this.currentType === 'video' && this.currentUrl.length > 0;
    },
    videoOptions() {
      return {
        autoplay: true,
        controls: true,
        loop: false,
        sources: [{
          src: this.sourceUrl,
          type: 'video/mp4',
        }],
        controlBar: {
          pictureInPictureToggle: false,
        },
      };
    },
  },
  created() {
    EventBus.$on(CAROUSEL_OPEN, (payload) => {
      this.currentUrl = payload.url;
      this.currentType = payload.type;
      this.open();
    });

    EventBus.$on(CAROUSEL_HIDE, () => {
      this.close();
      this.currentUrl = '';
      this.currentType = '';
    });
  },
  destroyed() {
    EventBus.$off(CAROUSEL_OPEN);
    EventBus.$off(CAROUSEL_HIDE);
  },
  methods: {
    open() {
      this.isOpened = true;
      this.$nextTick(() => this.$refs.chatCarousel.focus());
    },
    close() {
      this.isOpened = false;
    },
  },
};
</script>
